import { render, staticRenderFns } from "./AutomationIntegrationAttributesMenu.vue?vue&type=template&id=65e569cd&"
import script from "./AutomationIntegrationAttributesMenu.vue?vue&type=script&lang=js&"
export * from "./AutomationIntegrationAttributesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports